// extracted by mini-css-extract-plugin
export default {"permit":"Permit_permit__1l7Mf","input":"Permit_input__5j9ri","button":"Permit_button__3WVSR","locked":"Permit_locked__2pjun","approved":"Permit_approved__66GvQ"};